import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Dropdown, Button, Icon } from '@softwaredev_cegeka/stix-core'
import { authenticatedUserStore } from '../../stores'
import defaultContact from '../../assets/images/default-contact.svg'
import AuthenticatedUserStore from '../../stores/AuthenticatedUserStore'
import ImpersonateMenu from './ImpersonateMenu'
import './userMenu.scss'

const { ORGANIZATION } = AuthenticatedUserStore.IMPERSONATE

const AvatarButton = React.forwardRef((props, ref) => {
    return (
        <Button variant="naked" {...props}>
            {authenticatedUserStore.userData &&
            authenticatedUserStore.userData.firstName ? (
                <div className={'user-data-wrapper'}>
                    <span className={'user-first-last-name'}>
                        {authenticatedUserStore.userData.firstName}{' '}
                        {authenticatedUserStore.userData.lastName}
                    </span>
                    {authenticatedUserStore.impersonated[ORGANIZATION] &&
                    authenticatedUserStore.impersonatedOrganization ? (
                        <span className={'impersonated-tenant'}>
                            {authenticatedUserStore.impersonatedOrganization}
                        </span>
                    ) : null}
                </div>
            ) : (
                ''
            )}
            <img className={'avatar'} alt="Avatar" src={defaultContact} />
            <Icon icon={'chevron-down'} />
        </Button>
    )
})

export default class UserMenu extends Component {
    render() {
        return (
            <Dropdown className={'login-menu'} alignRight>
                <Dropdown.Toggle as={AvatarButton} id="user-dropdown-menu" />
                <Dropdown.Menu>
                    <NavLink className="stix-dropdown-item" to={'/account'}>
                        My account
                    </NavLink>
                    <ImpersonateMenu />
                    <Dropdown.Divider />
                    <NavLink className="stix-dropdown-item" to={'/logout'}>
                        Logout
                    </NavLink>
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}
